import { createClient, type SupabaseClient } from "@supabase/supabase-js";

export interface AuthConfig {
  url: string | null;
  anonKey: string | null;
  schema: string;
}

export const DEFAULT_DB_SCHEMA = "onchainreps";

export type AppSupabaseClient = SupabaseClient<any, string, string, any, any>;

export function authConfig(): AuthConfig {
  const env = import.meta.env as Record<string, string | undefined>;
  return {
    url: env.VITE_SUPABASE_URL ?? null,
    anonKey: env.VITE_SUPABASE_ANON_KEY ?? null,
    schema: env.VITE_SUPABASE_SCHEMA ?? DEFAULT_DB_SCHEMA,
  };
}

export function isAuthConfigured(): boolean {
  const config = authConfig();
  return Boolean(config.url && config.anonKey);
}

export function isGoogleAuthEnabled(): boolean {
  const env = import.meta.env as Record<string, string | undefined>;
  return env.VITE_SUPABASE_GOOGLE === "1";
}

let client: AppSupabaseClient | null = null;

export function supabase(): AppSupabaseClient | null {
  if (!isAuthConfigured()) return null;
  if (client) return client;
  const config = authConfig();
  client = createClient(config.url as string, config.anonKey as string, {
    db: { schema: config.schema },
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }) as AppSupabaseClient;
  return client;
}
